/** Toast "LEVEL UP" transitório ao subir de nível. */
import { events } from "../core/Events";
import { i18n } from "../i18n/i18n";

export class LevelUpToast {
  constructor(private readonly uiRoot: HTMLElement) {
    events.on("level:up", () => this.show());
  }

  private show(): void {
    const el = document.createElement("div");
    el.className = "levelup";
    el.textContent = i18n.t("player.levelUp");
    this.uiRoot.appendChild(el);
    // a animação CSS dura ~1.6s; remove depois
    window.setTimeout(() => el.remove(), 1700);
  }
}
